interface StatusPillProps {
  status: string;
  label?: string;
}

type Variant = 'success' | 'warning' | 'destructive' | 'primary' | 'muted';

const STATUS_VARIANT: Record<string, Variant> = {
  pending: 'warning',
  pending_payment: 'warning',
  requested: 'warning',
  confirmed: 'primary',
  confirmed_deposit: 'primary',
  paid: 'success',
  checked_in: 'primary',
  checked_out: 'success',
  completed: 'muted',
  cancelled: 'destructive',
  no_show: 'destructive',
  valid: 'success',
  expiring: 'warning',
  expired: 'destructive',
};

const STATUS_LABEL: Record<string, string> = {
  pending: 'Pending',
  pending_payment: 'Awaiting payment',
  requested: 'Requested — awaiting approval',
  confirmed: 'Confirmed',
  confirmed_deposit: 'Deposit paid',
  paid: 'Paid',
  checked_in: 'Checked in',
  checked_out: 'Checked out',
  completed: 'Completed',
  cancelled: 'Cancelled',
  no_show: 'No show',
  valid: 'Valid',
  expiring: 'Expiring',
  expired: 'Expired',
};

const VARIANT_STYLES: Record<Variant, React.CSSProperties> = {
  success: {
    color: 'var(--success, oklch(0.52 0.105 150))',
    background: 'oklch(0.52 0.105 150 / 0.1)',
  },
  warning: {
    color: 'var(--warning-foreground, oklch(0.22 0.04 75))',
    background: 'oklch(0.68 0.12 78 / 0.14)',
  },
  destructive: {
    color: 'var(--destructive, oklch(0.55 0.15 30))',
    background: 'oklch(0.55 0.15 30 / 0.1)',
  },
  primary: {
    color: 'var(--primary, oklch(0.43 0.18 263))',
    background: 'oklch(0.43 0.18 263 / 0.1)',
  },
  muted: {
    color: 'var(--muted-foreground, oklch(0.52 0.008 75))',
    background: 'oklch(0.52 0.008 75 / 0.1)',
  },
};

import type React from 'react';

export function StatusPill({ status, label }: StatusPillProps) {
  const variant = STATUS_VARIANT[status] ?? 'muted';
  const text = label ?? STATUS_LABEL[status] ?? status;
  const variantStyle = VARIANT_STYLES[variant];

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        padding: '0.15rem 0.55rem',
        borderRadius: '99px',
        fontSize: '0.72rem',
        fontWeight: 500,
        letterSpacing: '0.01em',
        ...variantStyle,
      }}
    >
      {text}
    </span>
  );
}
